import { composedParentElement } from 'utils/core'

export const isRangeAccessibility = (range: Range): boolean => {
  const { startContainer, endContainer } = range

  const isAccessibilityNode = (node: Node): boolean => {
    let current: Node | null = node

    while (current && current.nodeType !== Node.DOCUMENT_NODE) {
      if (current.nodeType === Node.TEXT_NODE) {
        current = composedParentElement(current)
        continue
      }

      if (current instanceof Element) {
        const elementTagName = current.tagName.toLowerCase()
        const isAccessibilityElement = ['title', 'desc', 'metadata'].includes(elementTagName)

        if (isAccessibilityElement && current.closest('svg') != null) {
          return true
        }
      }

      current = composedParentElement(current)
    }

    return false
  }

  return isAccessibilityNode(startContainer) && isAccessibilityNode(endContainer)
}
